import { inject } from '@angular/core'
import type { ActivatedRouteSnapshot, CanActivateFn, Params, Route } from '@angular/router'
import { Router } from '@angular/router'

import { ErrorHandlers } from '@app/services/error-handlers.service'

const applyParams = (templatePath: string, params: Params): string =>
  Object.entries(params).reduce((previousValue, [key, value]) => previousValue.replace(':' + key, value), templatePath)

const redirectTrackingMiddleware =
  (redirectTo: string, route: Route): CanActivateFn =>
  ({ params }: ActivatedRouteSnapshot) => {
    const router = inject(Router)

    ErrorHandlers.handleError(new Error(`Legacy redirect in use, redirecting from '${route.path}' to '${redirectTo}'`))
    const redirectPath = applyParams(redirectTo || '', params)
    return router.parseUrl(redirectPath)
  }

export const trackRedirectRoute = (route: Route & { redirectTo: string }): Route => {
  const { redirectTo, ...rest } = route

  if (redirectTo === undefined) {
    ErrorHandlers.handleError(new Error('Applying redirect tracking to non-redirect route'))
    return route
  }

  return {
    ...rest,
    canActivate: [redirectTrackingMiddleware(redirectTo, route)],
    children: [],
  }
}
